import React, { FC, Fragment } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Helmet } from 'react-helmet-async';

type PageTitleProps = {
    title?: string;
    dbId?: string;
    headingStyle: 'h1' | 'h2' | 'h3';
    showBackButton?: boolean;
    onBackArrow?: () => void;
    disableGutter?: boolean;
};

const PageTitle: FC<PageTitleProps> = ({
    title,
    dbId,
    headingStyle,
    showBackButton,
    onBackArrow,
    disableGutter,
}: PageTitleProps) => {
    return (
        <Fragment>
            {headingStyle === 'h1' ? (
                <Helmet>
                    <title>{title} | Denthub</title>
                </Helmet>
            ) : undefined}

            <Box mb={disableGutter ? 0 : headingStyle === 'h1' ? 3 : 2} display="flex" alignItems="center">
                {showBackButton && onBackArrow ? (
                    <IconButton size="small" onClick={() => onBackArrow()}>
                        <ArrowBackIcon />
                    </IconButton>
                ) : undefined}
                <Box>
                    <Typography variant={headingStyle} component="h1">
                        {title}
                    </Typography>
                    {dbId ? (
                        <Typography color="gray" variant="caption">
                            {dbId}
                        </Typography>
                    ) : undefined}
                </Box>
            </Box>
        </Fragment>
    );
};

export default PageTitle;
